import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { TOI_LIVE_DOMAIN } from '../../../../constants';
import s from './Socials.scss';
import {
  followUsLinksTwitter,
  followUsLinksFacebook,
  followUsLinksInstagram,
  // followUsLinksKoo,
  followUsYoutube,
  followUsLinksGoogle,
  followUsLinksTelegram,
} from '../../../../utils/common';

class Socials extends React.Component {
  componentDidMount() {
    const { isFooter, isMweb } = this.props;
    // Remove web_top_header_toi GA by !isMweb Check TOIPR-70372
    if (!isFooter && isMweb) {
      sendGaThroughProps({
        data: {
          gaCategory: isMweb ? 'mWeb_top_header_toi' : 'web_top_header_toi',
          gaAction: 'social_profile_icons',
          gaLabel: 'view',
          nonInteraction: true,
        },
      });
    }
  }
  render() {
    const {
      colorTheme,
      showTitle,
      // showKoo,
      showGnews,
      showWiki,
      isFooter,
      sectionName,
      isMweb,
    } = this.props;
    const theme = colorTheme ? s[colorTheme] : '';
    let gaAction;
    if (isMweb && isFooter) {
      gaAction = 'mWeb_bottom_footer_toi';
    } else if (isFooter) {
      gaAction = 'web_bottom_footer_toi';
    } else {
      gaAction = 'web_top_header_toi';
    }
    return (
      <>
        {showTitle ? (
          <div className={`${isFooter ? 'social_footer_heading' : ''}`}>
            Follow Us On
          </div>
        ) : (
          ''
        )}
        <ul
          className={`${s.sociable} ${theme} ${
            isFooter ? 'social_footer' : ''
          }`}
        >
          {showGnews ? (
            <li className={s.gnews}>
              <Link
                target="_blank"
                rel="nofollow noreferrer"
                className={s['sports-sprite']}
                //data-ga="top_header|social_profile_icons|social_koo"
                data-ga={`${gaAction}|social_profile_icons|click_social_google_news`}
                to={
                  followUsLinksGoogle[sectionName]
                    ? followUsLinksGoogle[sectionName]
                    : followUsLinksGoogle.toi
                }
                title="Google News"
              />
            </li>
          ) : (
            ''
          )}
          <li className={s.fb}>
            {/* This is done to not send GA in case of web_top_header_toi TOIPR-70372 */}
            {gaAction === 'web_top_header_toi' ? (
              <Link
                target="_blank"
                rel="nofollow noreferrer"
                className={s['sports-sprite']}
                to={
                  followUsLinksFacebook[sectionName]
                    ? followUsLinksFacebook[sectionName]
                    : followUsLinksFacebook.toi
                }
                title="Facebook"
              />
            ) : (
              <Link
                target="_blank"
                rel="nofollow noreferrer"
                className={s['sports-sprite']}
                // data-ga="top_header|social_profile_icons|social_fb"
                data-ga={`${gaAction}|social_profile_icons|click_social_facebook`}
                to={
                  followUsLinksFacebook[sectionName]
                    ? followUsLinksFacebook[sectionName]
                    : followUsLinksFacebook.toi
                }
                title="Facebook"
              />
            )}
          </li>
          <li className={s.twitter}>
            <Link
              target="_blank"
              rel="nofollow noreferrer"
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_twitter"
              data-ga={`${gaAction}|social_profile_icons|click_social_twitter`}
              to={
                followUsLinksTwitter[sectionName]
                  ? followUsLinksTwitter[sectionName]
                  : followUsLinksTwitter.toi
              }
              title="Twitter"
            />
          </li>
          <li className={s.rss}>
            <Link
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_rss"
              data-ga={`${gaAction}|social_profile_icons|click_social_rss`}
              to={`${TOI_LIVE_DOMAIN}/rss.cms`}
              title="RSS"
              target="_blank"
              doNotChangeURL
            />
          </li>
          <li className={s.youtube}>
            <Link
              target="_blank"
              rel="nofollow noreferrer"
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_youtube"
              data-ga={`${gaAction}|social_profile_icons|click_social_youtube`}
              to={
                followUsYoutube[sectionName]
                  ? followUsYoutube[sectionName]
                  : followUsYoutube.toi
              }
              title="YouTube"
            />
          </li>
          <li className={s.insta}>
            <Link
              target="_blank"
              rel="nofollow noreferrer"
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_youtube"
              data-ga={`${gaAction}|social_profile_icons|click_social_instagram`}
              to={
                followUsLinksInstagram[sectionName]
                  ? followUsLinksInstagram[sectionName]
                  : followUsLinksInstagram.toi
              }
              title="Instagram"
            />
          </li>
          <li className={s.linkedin}>
            <Link
              target="_blank"
              rel="nofollow noreferrer"
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_youtube"
              data-ga={`${gaAction}|social_profile_icons|click_social_linkedin`}
              to="https://www.linkedin.com/company/timesofindia/"
              title="Linkedin"
            />
          </li>
          {/* {showKoo ? (
            <li className={s.koo}>
              <Link
                target="_blank"
                rel="nofollow noreferrer"
                className={s['sports-sprite']}
                //data-ga="top_header|social_profile_icons|social_koo"
                data-ga={`${gaAction}|social_profile_icons|click_social_koo`}
                to={
                  followUsLinksKoo[sectionName]
                    ? followUsLinksKoo[sectionName]
                    : followUsLinksKoo.toi
                }
                title="Koo"
              />
            </li>
          ) : (
            ''
          )} */}
          {showWiki ? (
            <li className={s.wikipedia}>
              <Link
                target="_blank"
                rel="nofollow noreferrer"
                className={s['sports-sprite']}
                //data-ga="top_header|social_profile_icons|social_wikipedia"
                data-ga={`${gaAction}|social_profile_icons|click_social_wikipedia`}
                to="https://en.wikipedia.org/wiki/The_Times_of_India"
                title="Wikipedia"
              />
            </li>
          ) : (
            ''
          )}
          <li className={s.telegram}>
            <Link
              target="_blank"
              rel="nofollow noreferrer"
              className={s['sports-sprite']}
              //data-ga="top_header|social_profile_icons|social_twitter"
              data-ga={`${gaAction}|social_profile_icons|click_social_telegram`}
              to={
                followUsLinksTelegram[sectionName]
                  ? followUsLinksTelegram[sectionName]
                  : followUsLinksTelegram.toi
              }
              title="Telegram"
            />
          </li>
        </ul>
      </>
    );
  }
}

Socials.propTypes = {
  colorTheme: PropTypes.string,
  showTitle: PropTypes.bool,
  showKoo: PropTypes.bool,
  showGnews: PropTypes.bool,
  showWiki: PropTypes.bool,
  isFooter: PropTypes.bool,
  sectionName: PropTypes.string,
  isMweb: PropTypes.bool,
};
Socials.defaultProps = {
  colorTheme: '',
  showTitle: false,
  showKoo: false,
  showGnews: false,
  showWiki: false,
  isFooter: false,
  sectionName: '',
  isMweb: false,
};
export default Socials;
